import { PhotoModel } from './protocols';

// For non-image files (documents, PDFs, etc.)
export interface FileAttachment {
    key: string;
    fileName: string;
    fileType: string; // e.g., 'pdf', 'docx', 'xlsx'
    mimeType: string; // e.g., 'application/pdf'
    storagePath: string;
    fileSize: number;
    uploadedBy: string; // UID
    uploadedAt: string; // Format: YYYY-MM-DD
    attachmentType: 'file'; // Discriminator
    displayName?: string; // Custom display name for the attachment
}

// Extended PhotoModel for images with additional metadata
export interface ImageAttachment extends PhotoModel {
    attachmentType: 'image';
    fileName?: string; // Original filename
    mimeType?: string; // MIME type
    displayName?: string; // Custom display name for the attachment
}

// Union type for attachments
// Images use ImageAttachment (extends PhotoModel) to reuse existing image components
// Non-images use FileAttachment
export type Attachment = ImageAttachment | FileAttachment;

// Type guard to check if attachment is an image
export const isImageAttachment = (attachment: Attachment): attachment is ImageAttachment => {
    return attachment.attachmentType === 'image';
};

